





































import Debug from 'debug'
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { lazyInject } from '@/app/container';
import { EventStream, EventStreamSymbol } from '@/app/event-stream/event-stream';
import {
  SelectedChapterPercentUpdated,
  SelectedChapterPercentUpdatedEventName
} from '@/app/statistics/events/section-interaction-events';
import { SelectOption, TocItem } from '@/app/shared/models';
import { setFocus } from '@/app/accessibility/accessibility-utils';
import sectionCompletionStoreModule from '@/app/statistics/state/section-completion-state';
import ProgressCircleComponent from '@/app/sidebar-navigation/components/progress-circle-component.vue';

const debug = Debug('chapter-select-component')

@Component({
  components: {
    ProgressCircleComponent
  }
})
export default class ChapterSelectComponent extends Vue {
  @Prop()
  public options: SelectOption[];

  @Prop({required: true})
  public selectedValue!: number|string;

  public selected: SelectOption|null = this.calculateSelected(this.selectedValue);
  public selectedIndex: number = this.calculateSelectedIndex(this.selectedValue);
  public focusedIndex: number|null = null;
  public listenerId: string|null = null;

  public open: boolean = false;

  private selectedChapterPercent: number = 0;

  @lazyInject(EventStreamSymbol)
  private eventStream: EventStream;

  public mounted(): void {
    $(document).on('click', (e) => {
      const targetClassName: string = (e.target as any).className;
      const allowedClassNames: string[] = ['selected-item', 'selected-item-icon', 'selected-item-label'];
      if (!allowedClassNames.includes(targetClassName)) {
        this.open = false;
      }
    });

    this.updateSelectedPercent(this.selectedValue);

    this.listenChapterPercentUpdated();
  }

  public onUp(): void {
    this.open = true;
    const nextIndex: number = this.focusedIndex === null
      ? this.selectedIndex
      : this.focusedIndex - 1;

    if (nextIndex >= 0) {
      this.focusedIndex = nextIndex;

      setFocus(`#${this.createItemId(nextIndex)}`);
    }
  }
  public onDown(): void {
    this.open = true;
    const nextIndex: number = this.focusedIndex === null
      ? this.selectedIndex
      : this.focusedIndex + 1;

    if (nextIndex < this.options.length) {
      this.focusedIndex = nextIndex;

      setFocus(`#${this.createItemId(nextIndex)}`);
    }
  }

  public createItemId(index: number): string {
    return `chapter-select-item-${index}`;
  }

  public getPercent(option?: SelectOption): number {

    if (!option) {
      return 0
    }

    const sectionId = option.value;
    debug('getPercent', sectionId, option)

    const sectionProgress = sectionCompletionStoreModule.completionItemsBySectionId[sectionId]
    debug('sectionProgress', sectionId, sectionProgress)

    const percent = sectionProgress ? Math.round(sectionProgress.progress.completion) : option.percent;
    debug('percent', percent);

    return percent
  }

  public destroyed(): void {
    if (this.listenerId !== null) {
      this.eventStream.removeListener(SelectedChapterPercentUpdatedEventName, this.listenerId);
    }
  }

  @Watch('selectedValue')
  public onSelectedValueChanged(newValue: number|string): void {
    this.selected = this.calculateSelected(newValue);
    this.selectedIndex = this.calculateSelectedIndex(newValue);

    this.updateSelectedPercent(newValue);
  }

  private updateSelectedPercent(selectedValue: number|string|undefined) {

    debug('updateSelectedPercent', this.options, selectedValue);
    const percent = this.resolveChapterPercent(selectedValue);
    debug('new percent', percent);
    this.selectedChapterPercent = percent;
  }

  private resolveChapterPercent(chapterId: string|number|undefined) {
    debug('resolveChapterPercent', chapterId, this.options);

    if (this.options && chapterId) {
      const item = this.options.find(x => x.value === chapterId);
      if (item) {
        const percent = this.getPercent(item);
        debug('percent', percent);
        return percent;
      }
    }

    debug('percent (because not found)', 0);
    return 0;
  }

  public onOptionClicked(option: SelectOption): void {
    this.selected = option;
    this.selectedIndex = this.calculateSelectedIndex(option.value);
    this.open = false;

    this.emitSelected();
  }

  @Emit('selected')
  public emitSelected(): SelectOption|null {
    return this.selected;
  }

  private listenChapterPercentUpdated(): void {
    this.listenerId = this.eventStream.listen(
        SelectedChapterPercentUpdatedEventName,
        (payload: SelectedChapterPercentUpdated) => {

          debug('chapter percent updated', payload, this.selected);

          const chapter: TocItem = payload.selectedChapter;
          const newPercent = this.resolveChapterPercent(payload.selectedChapter?.id)
          debug('selected', this.selected ? this.selected.value : '',
                'payload', payload.sectionId,
                'percent', newPercent);
          if (this.selected
                && this.selected.value === payload.sectionId
                && this.selected.percent !== newPercent) {

            debug('chapter percent updated', payload.sectionId, payload, this.selected, newPercent);
            this.selected.percent = newPercent;
            this.selectedChapterPercent = newPercent;
          }
        });
      }

  private calculateSelected(selectedValue: number|string): SelectOption|null {
    return this.options.find((option: SelectOption) => option.value === selectedValue) || null;
  }

  private calculateSelectedIndex(selectedValue: number|string): number {
    return this.options.findIndex((option: SelectOption) => option.value === selectedValue) + 1;
  }
}
